import "./assets/packages/IRANSans/Farsi_numerals/webFonts/css/fontiran.css";
import "./assets/packages/IRANSans/WebFonts/css/fontiran.css";
import "./assets/packages/bootstrap-5.0.1-dist/css/bootstrap.min.css";
import "./assets/packages/fontawesome/css/all.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import CheckPhoneNumber from "./pages/CheckPhoneNumber";
import ConfirmMobile from "./pages/ConfirmMobile";
import ConfirmPasswordReset from "./pages/ConfirmPasswordReset";
import EditAddress from "./pages/EditAddress";
import EditUser from "./pages/EditUser";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Header from "./components/Header";
import Footer from "./components/Footer";
import IsUserAuth from "./components/IsUserAuth";
//import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import 'mapir-react-component/dist/index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Helmet } from "react-helmet";
function App() {
  return (
    <BrowserRouter>
       <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Switch>
        <Route
          exact
          path={[
            "/user/login",
            "/user/confirm-mobile",
            "/user/confirm-password-reset",
          ]}
        >
          <IsUserAuth />
          <div className="App">
  {/*          <GoogleReCaptchaProvider reCaptchaKey="6Le05tsqAAAAAPDwhxolFahvIisrci5_75QTq4pk">  */} 
              <Route path="/user/confirm-mobile" component={ConfirmMobile} />
              <Route
                path="/user/confirm-password-reset"
                component={ConfirmPasswordReset}
              />
              <Route path="/user/login" component={Login} />
     {/*         </GoogleReCaptchaProvider>  */} 

          </div>
        </Route>
        <Route exact path={["/user/register", "/user"]}>
          <IsUserAuth />
          <div className="App">
            <Route exact path="/user" component={CheckPhoneNumber} />
            <Route path="/user/register" component={Register} />
          </div>
        </Route>
        <Route path={["/user/edit-address", "/user/edit"]}>
          <Header />
          <Route path="/user/edit-address" component={EditAddress} />
          <Route path="/user/edit" component={EditUser} />
          <Footer />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
